import { h } from 'vue';
import App from './app.vue';
import TrainingLayout from './components/TrainingLayout.vue';

/**
 * The root component main.js mounts. What it renders is decided by the boot's
 * /users/me round trip (`boot`, a reactive main.js owns) and by the store:
 *
 *   - the boot error, when the API could not be reached;
 *   - the bare training layout, for a gated user (spec 53 3.3): the company
 *     name, their name and Sign out around the training pages, and nothing
 *     that polls. The shell is never mounted, so its rail, bells and live
 *     map never ask for anything that would answer 403;
 *   - the shell (app.vue), for everyone else.
 *
 * Its own module so a test can mount exactly what the browser mounts.
 */
export function createRoot({ boot, store, renderBootError }) {
  return {
    name: 'Root',
    render() {
      if (boot.error) return renderBootError();
      if (store.getters.trainingGated) return h(TrainingLayout, { user: boot.user });
      return h(App, { user: boot.user });
    },
  };
}
